<template>
    <!--            &#45;&#45; Tailwind UI -> Data Display -> Description Lists -> Left-aligned in card &#45;&#45;-->
    <div class="w-full bg-white border border-t-0 border-gray-200 overflow-hidden sm:rounded-b-lg">
        <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
            <p class="mt-1 text-sm leading-5 text-gray-500">
                Add a comment to the alarm; this won't change the alarm status.
            </p>
        </div>
        <div class="px-4 py-5 sm:p-0">
            <dl>
                <div class="mt-2 sm:mt-0 sm:grid sm:grid-cols-4 sm:gap-6 sm:px-6 sm:py-5">
                    <dt class="text-sm leading-5 font-medium text-gray-500">
                        Comments<span v-if="requireComment" class="text-red-500 ml-0.5">*</span>
                        <p v-if="requireComment" class="mt-1 text-base font-normal text-gray-500">
                            {{ policyText('requireComment') }}
                        </p>
                    </dt>
                    <dd class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-3">
                        <textarea v-model="comments" class="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6" rows="4"
                                  placeholder="Enter any comments here"></textarea>
                    </dd>
                </div>
            </dl>
        </div>
        <div class="px-4 py-5 sm:border-t mt-2 p-1">
            <dl class="mb-0 flex sm:justify-end">
                    <span class="mt-3 inline-flex w-full rounded-md sm:mt-0 sm:w-auto" :class="!anythingEntered ? 'cursor-not-allowed' : ''">
                        <button type="button"
                                @click="sendFormData"
                                :disabled="!anythingEntered"
                                :class="!anythingEntered ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-500 active:bg-blue-700 cursor-pointer'"
                                class="w-full inline-flex items-center justify-center min-w-80 px-4 py-2 border border-transparent font-medium rounded-md text-white focus:outline-none focus:border-blue-700 focus:ring-indigo-200 sm:w-auto sm:text-sm sm:leading-5">
                          Place comment on alarm
                        </button>
                      </span>
            </dl>
        </div>
    </div>

</template>

<script>
    import axios from 'axios';
    import { alarmPolicyText } from "@/support/alarmPolicyCopy";

    export default {
        name: "alarmAddressComment",
        props: {
            sendEventOnly: Boolean,
            requireComment: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                comments: '',
            }
        },
        computed: {
            anythingEntered: function () {
                return this.comments.trim().length > 0;
            }
        },
        methods: {
            policyText(key) {
                return alarmPolicyText(key);
            },
            sendFormData() {
                // Data to send to form
                let data = {
                    'addressed': 'comment',
                    'comments': this.comments,
                }
                if (this.sendEventOnly) {
                    // If we're only sending the event, emit the event and return
                    this.$emit('adding-comment', data)
                    return
                }

                // Send the data to the server and emit the response.
                axios.patch(window.location.pathname,
                    data
                ).then(response => {
                    this.$emit('add-comment', response.data)
                    this.comments = ''
                });
            },
        }
    }
</script>

<style scoped>

</style>